/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React, { useState, useEffect } from "react";
import "./EventsSection.css";

function EventsSection() {
  const [eventsData, setEventsData] = useState([]);

  useEffect(() => {
    fetch("events.json")
      .then((response) => response.json())
      .then((data) => setEventsData(data))
      .catch((error) => console.log(error));
  }, []);

  return (
    
    <div className="">
      <section className="eventtop__section">
        <header>
          <h1>EVENTOS</h1>
        </header>
      </section>
       <div className="card-container">
      {eventsData.map((event) => (
        <div className="card" key={event.id}>
          <img src={event.imageUrl} alt={`${event.eventName}`} />
          <p id="location">{event.location}</p>
          <p id="fecha">Fecha: {event.date}</p>
          <p id="horario">Horario: {event.time}</p>
          <p id="state">{event.state}</p>
          {event.GA.link && (
            <a rel="noopener noreferrer" href={event.GA.link} target="_blank">
              <button>Boletos</button>
            </a>
          )}
          {event.VIP.link && (
            <a rel="noopener noreferrer" href={event.VIP.link} target="_blank">
              <button>Boletos VIP</button>
            </a>
          )}
        </div>
      ))}
      </div>
    </div>
  );
}

export default EventsSection;